/**
 * components.js
 *
 * Import the JS for your components here.
 *
 */
import './BackToTop/BackToTop';
import './Modal/Modal';
import CopyPageUrl from './SocialShare/SocialShare';
import Slider from './Slider/Slider';
import MembershipTable from './MembershipTable/MembershipTable';
import ComponentInit from '../js/utils/ComponentInit';
import InitializeFader from './Fader/Fader';
import CardEvent from './Cards/CardEvent/CardEvent';

// Format:
// data-component-name: ComponentFunction
// we shall order these in page load critical first
const componentList = { Slider, CopyPageUrl, MembershipTable, InitializeFader, CardEvent };

// eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
export default ComponentInit(componentList);
